<template>

  <pdf v-if="isPdf" :src="setAnyImage" :alt="imgAlt" :data-image="setFullImage" @mouseenter="moving" @mouseleave="stopped" @click.stop="openOverView($event, fullScreen)" role="button" area-label="PDFサムネイル"></pdf>

	<video v-else-if="isMov" autoplay loop muted :src="setAnyImage" :data-image="setFullImage" type="video/mp4" :poster="setPoster"  :alt="imgAlt"  @click.stop="openOverView($event, fullScreen)" role="button" area-label="映像"></video>

  <img v-else :src="setAnyImage" :alt="imgAlt" :data-image="setFullImage" @mouseenter="moving" @mouseleave="stopped" role="button" tabIndex={0} @click.stop="openOverView($event, fullScreen)" :class="{cursorZoomIn:fullScreen}" :width="imgWidth" :height="imgHeight" area-label="画像" v-on:load="imgLoaded" v-on:error="imgLoadError">

</template>

<script>
/*imgPlusとの違いについて
静的なイメージ読み込みはimgPlusStatic
動的なイメージ読み込みはimpPlusを

映像、pdf、読み込み監視などの処理は不要。
マウスオン zoomと拡大処理のみ提供できればいい
*/

/*src指定がpdfの場合、vue-pdfを利用して処理するようにする*/
import pdf from 'vue-pdf'

/*
表示画像セットについて
表示元がリスト内か単体かによって対応を変える。
リストの場合は、映像でもサムネイル画像をセット
単体表示では、サムネイル指定がない場合は、オリジン画像をセットする
ともに指定画像がない場合は、[noImage]をセットする

拡大表示用画像セットについて
オリジン画像をセットする
画像指定がない場合は、""をセットする
*/

export default {
  name: 'imgPlusStatic',
  props: {
    imgSrc:{ //
      type:String,
      default:"",
    },
    imgAlt:{
      type:String,
      default:"",
    },
		imgThumb: { //サムネイル 映像ではposter要素
			type:String,
		},
		fullScreen:{ //拡大機能：true > on,  false > off
			type:Boolean,
		},
		atPlace:{ //使用箇所： "single", "list"
			type:String,
			default:"single"
		},
  },
  components:{
    pdf,
  },
  data() {
    return {
			loading:true,
			imgWidth:0,
			imgHeight:0,
    }
  },
  computed:{
    isPdf:function() {
      return this.imgSrc != null && this.imgSrc.toLowerCase().indexOf(".pdf") !== -1
    },
    isMov:function() {
      return this.imgSrc != null && this.imgSrc.toLowerCase().indexOf(".mp4") !== -1 && (this.atPlace == "single" )
    },

/*表示イメージURLセット*/
		setAnyImage:function() {
//			let aImage = require("@/asset/images/noImage.svg")
			let aImage = "pages/noImage.svg"
			if(this.atPlace == "list") {		//リスト表示の場合
				if((this.imgThumb != "")&&(this.imgThumb != null))  {				//サムネイルをsrcにセットする
					aImage = this.imgThumb
				} else if((this.imgSrc != "" )&&(this.imgSrc != null) ){   //サムネイル指定がない場合、オリジンをsrcにセットする
					aImage = this.imgSrc
				} else {																	//オリジンの指定もない場合、[noImage]をセットする
				}
			} else {                                 //単体表示の場合
				if((this.imgSrc != "" )&&(this.imgSrc != null) ){
					aImage = this.imgSrc         //オリジンをsrcにセットする
				}
			}
			return this.getExtImageDir() + aImage
		},
/*拡大イメージURLセット*/
		setFullImage:function() {
			let aImage = ""
			if((this.imgSrc != "" )&&(this.imgSrc != null )) {         //リスト、単体関係なくあればオリジンをsrcにセットする
				aImage = this.getExtImageDir() + this.imgSrc
			}
			return aImage
		},
/*映像の場合 posterをセットする*/
		setPoster:function() {
				return this.getExtImageDir() + this.imgThumb
		},

/*
		isNot:function() {
			return  (this.imgSrc ==null )?  require("@/asset/images/noImage.svg"): this.getExtImageDir() + this.imgSrc
		},
		setDirFile:function() {
			return this.getExtImageDir() + this.imgSrc
		},
		setDirFullImage:function() {
			return  (this.imgFull ==null )?  require("@/asset/images/noImage.svg"): this.getExtImageDir() + this.imgFull
		},
*/

		overViewEnable() {
				return this.fullScreen
		},
  },
  created:function() { this._log("created "+this.$options.name)
  },
  beforeUpdate:function() {this._log("beforeUpdate "+this.$options.name)
	},
  methods:{
/*
		isNot:function() {
console.log(this.imgSrc)
			return  (this.imgSrc ==null )?  require("@/asset/images/noImage.svg"): this.getExtImageDir() + this.imgSrc
		},
*/

    moving:function(e) {
//      e.target.classList.remove("re-moving")
      e.target.classList.add("expansion")
    },
    stopped:function(e) {
      e.target.classList.remove("expansion")
    },
    takeFileName:function(aUrl) {
      return aUrl.match(".+/(.+?)([?#;].*)?$")[1]
    },
    innerImage:function(aUrl) {
      return require(aUrl)
    },
		imgLoaded:function(e) {
//console.log("imgLoaded", e.target)
		this.imgWidth = e.target.naturalWidth
		this.imgHeight = e.target.naturalHeight

			this.loading=false
    },
		imgLoadError:function(e) {
//console.log("imgLoadError", e.target)
			this.loading=true
		},
  },
}
</script>

<style scoped>
</style>